import React from 'react';
import { useCases } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-184" data-mp="3kqnr2roynv4e">
      <div className="mx-auto max-w-5xl" data-id="element-185" data-mp="3kr5t64yb13k8">
        <h2 className="text-center text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.4rem]" data-id="element-186" data-mp="3fz5oy0b7bohu">
          Ways to Use the Kit
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-stone-700" data-id="element-187" data-mp="3ayhxjdj295n3">
          Flexible materials for adult learners in different teaching settings
        </p>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-188" data-mp="31z37ugapwz3n">
          {useCases.map(item => <li key={item.title} className="flex h-full flex-col rounded-2xl bg-stone-100 p-6" data-id="element-189" data-mp="2x1l0guccmrxr">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-red-500" data-id="element-190" data-mp="2s308fi793eke">
                {item.label}
              </p>
              <h3 className="mt-4 text-base font-bold text-stone-900" data-id="element-191" data-mp="qac415ivel31">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-700" data-id="element-192" data-mp="h5f0vqsro53b">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}